/**
 * Utility function to process row class styling for TableAdv component
 * Applies conditional styling to table rows based on row data
 * @param {Object} row - The row data object
 * @param {Array} columns - Array of column configurations to find getRowClass function
 * @returns {string} CSS class names to apply to the row
 */
const processRowClass = (row, columns) => {
  if (!row || !columns || !Array.isArray(columns)) return '';
  
  try {
    // Find a column with getRowClass function
    const columnWithRowClass = columns.find(col => typeof col.getRowClass === 'function');
    
    if (columnWithRowClass) {
      // Call the provided function with the row data
      const customClasses = columnWithRowClass.getRowClass(row);
      
      // Return the custom classes if they exist
      return customClasses || '';
    }
    
    return '';
  } catch (error) {
    console.error('Error processing row class:', error);
    return '';
  }
};

export default processRowClass;